import { httpGet } from 'src/utils/http';

export const apiGetExperimentalToggleEnabled = (flagName: string): Promise<boolean> =>
  httpGet('/featuretoggle/istoggleenabled', {
    toggleName: flagName,
  });
